import styled from 'styled-components';

export const Label = styled.p`
  text-align: left;
  margin: 0px;
  @media (max-width: 1030px) {
    font-size: 9pt;
  }
`;

export const LabelDefault = styled.p`
  text-align: left;
  margin: 0px;
  color: #d40d27 !important;
  @media (max-width: 1030px) {
    font-size: 9pt;
  }
`;

export const InputContain = styled.section`
  position: relative;
  margin-bottom: 15px;
  p {
    margin: 0 0 0.7rem;
    color: var(--texto-color);
    letter-spacing: 0.1rem;
    font-size: var(--font-tamanho);
  }
  input {
    width: 100%;
    margin-bottom: 0;
    height: 50px;
    padding: 10px 12px;
    border-radius: 0.5rem;
    font-size: 11pt;
    &::placeholder {
      color: var(--cinza-color);
    }
  }
`;
